var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import makeStyles from '@mui/styles/makeStyles';
import SvgIcon from '@mui/material/SvgIcon';

var useStyles = makeStyles(function (theme) {
  return {
    paperItem: {
      alignItems: 'baseline'
    },
    itemTitle: _extends({}, theme.typography.body2, {
      color: theme.palette.primary.main
    }),
    button: {
      '&:hover': {
        backgroundColor: R.path(['palette', 'tertiary', 'light'])(theme) || theme.palette.secondary.light
      },
      padding: theme.spacing(1.25),
      textAlign: 'left',
      textTransform: 'none',
      justifyContent: 'flex-start',
      display: 'flex'
    },
    itemSubtitle: _extends({}, theme.typography.body1, {
      display: 'flex',
      flexDirection: 'column',
      color: theme.palette.grey[800]
    }),
    itemSubtitleLink: _extends({}, theme.typography.body1, {
      color: theme.palette.grey[800],
      '&:hover': {
        color: theme.palette.primary.main
      }
    }),
    svg: {
      color: theme.palette.grey[600],
      fontSize: '1rem',
      marginRight: theme.spacing(0.5),
      marginTop: theme.spacing(0.25),
      marginBottom: 'auto'
    }
  };
});

var Item = function Item(_ref) {
  var parentId = _ref.parentId,
      item = _ref.item,
      action = _ref.action,
      testId = _ref.testId,
      isSecondLevelClikable = _ref.isSecondLevelClikable,
      labelAccessor = _ref.labelAccessor;

  var classes = useStyles();

  return React.createElement(
    Grid,
    { className: classes.paperItem },
    React.createElement(
      Button,
      {
        'aria-label': R.prop('label')(item),
        className: classes.button,
        fullWidth: true,
        'data-testid': testId,
        role: 'link',
        onClick: function onClick() {
          if (R.not(R.is(Function)(action))) return;
          action(parentId, R.prop('id')(item));
        },
        tabIndex: 0
      },
      React.createElement(
        SvgIcon,
        { className: classes.svg },
        React.createElement('path', { d: R.prop('svgPath')(item) })
      ),
      React.createElement(
        Grid,
        { container: true, item: true, xs: 12, direction: 'column' },
        React.createElement(
          'span',
          { className: classes.itemTitle },
          labelAccessor(item, parentId)
        ),
        React.createElement(
          'span',
          { className: classes.itemSubtitle },
          R.map(function (subtopic) {
            if (R.not(R.is(Object)(subtopic))) return subtopic;
            if (R.not(isSecondLevelClikable)) return labelAccessor(subtopic, parentId);
            var id = R.prop('id')(subtopic);
            return React.createElement(
              Link,
              {
                key: id,
                className: classes.itemSubtitleLink,
                role: 'link',
                onClick: function onClick(e) {
                  if (R.not(R.is(Function)(action))) return;
                  action(parentId, id);
                  e.stopPropagation();
                },
                tabIndex: 0,
                underline: 'none',
                style: { display: 'list-item' }
              },
              labelAccessor(subtopic, parentId)
            );
          })(R.pipe(R.propOr([], 'subtopics'), R.ifElse(R.always(isSecondLevelClikable), R.identity, R.intersperse(' • ')))(item))
        )
      )
    )
  );
};

Item.propTypes = process.env.NODE_ENV !== "production" ? {
  parentId: PropTypes.string,
  testId: PropTypes.string,
  item: PropTypes.object,
  action: PropTypes.func,
  isSecondLevelClikable: PropTypes.bool,
  labelAccessor: PropTypes.func
} : {};

export default Item;